import { render, staticRenderFns } from "./CrewwatchView.vue?vue&type=template&id=4914dcb2&"
import script from "./CrewwatchView.vue?vue&type=script&lang=js&"
export * from "./CrewwatchView.vue?vue&type=script&lang=js&"
import style0 from "./CrewwatchView.vue?vue&type=style&index=0&id=4914dcb2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports